



















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class RegisterLevelProgress extends Vue {
  levels = [
    { index: 0, name: "اطلاعات ورود" },
    { index: 1, name: "اطلاعات فروشگاه" },
  ];
  @Prop({ default: 0 }) level: number;

  levelDotClass(i: number) {
    return this.level > i ? "passed" : this.level === i ? "active" : "";
  }

  public get wormBottom(): string {
    const inverseIndex = this.levels.length - this.level;
    return `calc(${inverseIndex * 50}%)`;
  }
}
